import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  countryCode: Yup.string(),
  number: Yup.string()
    .trim()
    .required('msg_error_required_field')
    .matches(/^[0-9]+$/, 'msg_error_invalid_phone')
    .max(15, 'msg_error_invalid_phone'),
});
